import { makeStyles } from "@material-ui/core/styles";

export default makeStyles(() => ({
  cont: {
    width: "100%",
  },
  img: {
    width: "100%",
  }
}))
